import React from 'react';
import { Button } from '../../components/ui/button';
import { KeyRound } from 'lucide-react';

export const PinPad = ({ pin, onPinChange, onSubmit, loading }) => {
  const addDigit = (digit) => {
    if (pin.length < 4) onPinChange(pin + digit);
  };

  return (
    <div className="space-y-2 sm:space-y-3">
      <div className="flex items-center justify-center gap-1 sm:gap-2 mb-1 sm:mb-2">
        <KeyRound className="h-3 w-3 sm:h-4 sm:w-4 text-primary" />
        <span className="font-medium text-xs sm:text-sm">PIN eingeben</span>
      </div>
      <form onSubmit={onSubmit} className="space-y-2 sm:space-y-3">
        {/* PIN Display */}
        <div className="flex justify-center gap-2 sm:gap-3 mb-2 sm:mb-4">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={`pin-${i}`}
              data-testid={`pin-dot-${i}`}
              className={`w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-md sm:rounded-lg border-2 flex items-center justify-center text-lg sm:text-xl md:text-2xl font-bold transition-all ${
                pin.length > i
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-gray-600 bg-gray-800'
              }`}
            >
              {pin.length > i ? '•' : ''}
            </div>
          ))}
        </div>

        {/* Number Pad */}
        <div className="grid grid-cols-3 gap-2 sm:gap-3 max-w-[200px] sm:max-w-[240px] md:max-w-[280px] mx-auto">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <Button
              key={num}
              type="button"
              variant="outline"
              data-testid={`pin-key-${num}`}
              className="h-12 sm:h-14 md:h-16 text-xl sm:text-2xl md:text-3xl font-bold rounded-lg sm:rounded-xl hover:bg-primary hover:text-primary-foreground transition-all bg-gray-800 border-gray-600 active:scale-95"
              onClick={() => addDigit(String(num))}
            >
              {num}
            </Button>
          ))}
          <Button
            type="button"
            variant="outline"
            data-testid="pin-key-clear"
            className="h-12 sm:h-14 md:h-16 text-sm sm:text-base font-medium rounded-lg sm:rounded-xl text-red-400 hover:bg-red-500 hover:text-white bg-gray-800 border-gray-600 active:scale-95"
            onClick={() => onPinChange('')}
          >
            C
          </Button>
          <Button
            type="button"
            variant="outline"
            data-testid="pin-key-0"
            className="h-12 sm:h-14 md:h-16 text-xl sm:text-2xl md:text-3xl font-bold rounded-lg sm:rounded-xl hover:bg-primary hover:text-primary-foreground transition-all bg-gray-800 border-gray-600 active:scale-95"
            onClick={() => addDigit('0')}
          >
            0
          </Button>
          <Button
            type="button"
            variant="outline"
            data-testid="pin-key-backspace"
            className="h-12 sm:h-14 md:h-16 text-base sm:text-lg rounded-lg sm:rounded-xl bg-gray-800 border-gray-600 active:scale-95"
            onClick={() => onPinChange(pin.slice(0, -1))}
          >
            ←
          </Button>
        </div>

        <Button
          type="submit"
          data-testid="pin-submit-btn"
          className="w-full max-w-[200px] sm:max-w-[240px] md:max-w-[280px] mx-auto block h-10 sm:h-12 text-sm sm:text-base rounded-lg sm:rounded-xl mt-2 sm:mt-4"
          disabled={pin.length !== 4 || loading}
        >
          {loading ? 'Prüfe...' : 'Bestätigen'}
        </Button>
      </form>
    </div>
  );
};
